import axios from 'axios';
import { createAsyncThunk } from "@reduxjs/toolkit";
import { ACCESS_TOKEN, API_BASE_URL } from '../consts';
import { AuthService } from '../authService';


export interface LoginRequest {
  email: string;
  password: string;
}

export interface SignUpRequest {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
}

export const userLogin = createAsyncThunk(
  'user/login',
  async ({ email, password }: LoginRequest, { rejectWithValue }) => {
    try {
      // configure header's Content-Type as JSON
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
      }

      const { data } = await axios.post(
        API_BASE_URL + '/auth/signin',
        { email, password },
        config
      )

      // store user's token in local storage
      localStorage.setItem(ACCESS_TOKEN, data.accessToken);

      return data;
    } catch (error: any) {
      // return custom error message from API if any
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message);
    }
  }
)

export const registerUser = createAsyncThunk(
  'user/register',
  async ({ firstName, lastName, email, password }: SignUpRequest, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
      }

      await axios.post(
        API_BASE_URL + '/auth/signup',
        { firstName, lastName, email, password },
        config
      )
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
);

export const validateUserToken = createAsyncThunk(
  'user/validateToken',
  async (_, { rejectWithValue, dispatch }) => {
    try {
      // First check basic token format
      if (!AuthService.hasValidTokenFormat()) {
        AuthService.clearInvalidToken();
        throw new Error('Invalid token format');
      }

      // Then validate with backend (interceptor will handle 401s)
      const result = await AuthService.validateToken();

      if (!result.valid) {
        AuthService.clearInvalidToken();
        throw new Error('Token validation failed');
      }

      return result;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);